import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  padding: 12px;
`;

export const Header = styled.div`
  margin-bottom: 12px;
`;

export const Title = styled.h2`
  color: var(--Color-2, #171717);
  font-family: Poppins;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
`;

export const HeaderDivider = styled.div`
  height: 1px;
  background: #D9D9D9;
  width: 100%;
  margin-bottom: 12px;
`;

export const Section = styled.div`
  margin-bottom: 15px;
`;

export const SectionTitle = styled.h3`
  color: #737373;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;
  margin: 0 0 8px 0;
`;

export const Row = styled.div<{ $color?: string }>`
  display: flex;
  align-items: center;
  flex-direction: row;
  background-color: #FFF4E480;
  border-top: 1px solid var(--Neutral-300, #CDCDCD);
  border-bottom: 1px solid var(--Neutral-300, #CDCDCD);
  position: relative;
  padding: 11px 0 11px 12px;
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin-top: 5px;
    width: 5px;
    height: calc(100% - 10px);
    border-radius: 0px 4px 4px 0px;
    background-color: ${props => props.$color || 'transparent'};
  }

  ${({ theme }) => theme.max("sm")`
    flex-direction: column;
    gap: 10px;
  `}
`;

export const Col = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.max("sm")`
    width: 100%;
  `}
`;

export const Input = styled.input`
  flex: 1;
  padding: 10px;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  font-family: Inter;
  font-size: 14px;
  color: #334155;
  
  &::placeholder {
    color: #94A3B8;
  }
  
  &:focus {
    outline: none;
    border-color: #3B82F6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin: 0 32px;
  border-radius: 50%;
  border: 1px solid rgba(100, 116, 139, 0.40);
  background: #fff;
  color: #64748B;
  font-family: Inter;
  font-size: 12px;
  line-height: 30px;
`;

export const Text = styled.p`
  color: var(--Generic-Black, #000);
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  word-break: break-word;
`;